import React from "react";
import api from "../../../api/Api";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import {NavLink} from "react-router-dom";
import FormControl from "@material-ui/core/FormControl";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Loader from "../../../components/Loader";
import InputLabel from "@material-ui/core/InputLabel";
import {dashboardRouter} from"../../../util/globalHelper"
const array1 = [];
const array2 = [];
const array3 = [];
const array4 = [];
const array5 = [];
const array6 = [];
const array7 = [];
const array8 = [];
const array9 = [];
const array10 = [];
const array11 = [];

class ClinicRoleUpdate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            role_keyState: "",
            role_key: "",
            clinicmaster_id: "",
            clinic_permission_id: null,
            description: "",
            descriptionState: "",
            name: "",
            last_name: "",
            is_active: null,
            nameState: "",
            last_nameState: "",
            alert: null,
            roleDetail: null,
            open: true, permissions: null, role_access: []


        }
        this.onChangeSelect = this.onChangeSelect.bind(this)
        this.onCheck = this.onCheck.bind(this)
        this.onGroupCheck = this.onGroupCheck.bind(this)
        this.checkAcesss = this.checkAcesss.bind(this)
        this.onCheckActive = this.onCheckActive.bind(this)
        this.removeRole = this.removeRole.bind(this)
        this.addRole = this.addRole.bind(this)
        this.onSubmit = this.onSubmit.bind(this)

    }

    componentDidMount() {
        this.CallReadApi(this.props.match.params.clinicMasterID, this.props.match.params.id)
        this.setState({clinicmaster_id: this.props.match.params.clinicMasterID, role_id: this.props.match.params.id})
    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    onCheckActive(e) {
        const state = this.state;
        state[e.target.name] = e.target.checked;
        this.setState(state);

    }

    onCheck(name, value) {
        const state = this.state;
        state[name] = value;
        value ? this.addRole(name) : this.removeRole(name);
        this.setState(state);
    }

    onGroupCheck(e) {
        var category = "array" + JSON.parse(e.target.name)
        switch (category) {
            case 'array1':
                array1.map(item => this.onCheck(`${item.permission_key}`, e.target.checked));
                break;
            case 'array2':
                array2.map(item => this.onCheck(`${item.permission_key}`, e.target.checked));
                break;
            case 'array3':
                array3.map(item => this.onCheck(`${item.permission_key}`, e.target.checked));
                break;
            case 'array4':
                array4.map(item => this.onCheck(`${item.permission_key}`, e.target.checked));
                break;
            case 'array5':
                array5.map(item => this.onCheck(`${item.permission_key}`, e.target.checked));
                break;
            case 'array6':
                array6.map(item => this.onCheck(`${item.permission_key}`, e.target.checked));
                break;
            case 'array7':
                array7.map(item => this.onCheck(`${item.permission_key}`, e.target.checked));
                break;
            case 'array8':
                array8.map(item => this.onCheck(`${item.permission_key}`, e.target.checked));
                break;
            case 'array9':
                array9.map(item => this.onCheck(`${item.permission_key}`, e.target.checked));
                break;
            case 'array10':
                array10.map(item => this.onCheck(`${item.permission_key}`, e.target.checked));
                break;
            case 'array11':
            default:
                array11.map(item => this.onCheck(`${item.permission_key}`, e.target.checked));
                break;
        }


    }

    addRole(name) {
        var array = this.state.role_access;
        var index = array.indexOf(name);
        if (index === -1)
            this.setState({role_access: this.state.role_access.push(name)})

    }

    removeRole(name) {
        var array = this.state.role_access;
        var index = array.indexOf(name);
        array.splice(index, 1);
        this.setState({role_access: array});
    }

    checkAcesss() {
        var array = this.state.roleDetail.role_access;
        array.map(item => (this.onCheck(item, true)))
    }


    render() {
        const {data, roleDetail} = this.state;
        if (this.state.data && this.state.permissions && this.state.roleDetail)
            return (<GridContainer>
                    {this.state.alert}
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="info" text>
                                <CardText color="info">
                                    <h4>Update Role</h4>
                                </CardText>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <form>
                                            <GridContainer>
                                                <GridItem xs={12} sm={5} md={5}>
                                                    <CustomInput
                                                        labelText="Role Key"
                                                        id="role_key"
                                                        success={this.state.role_keyState === "success"}
                                                        error={this.state.role_keyState === "error"}
                                                        formControlProps={{
                                                            fullWidth: true,
                                                            required: true
                                                        }}
                                                        inputProps={{
                                                            onChange: event =>
                                                                this.change(event, "role_key", "name", "required"),
                                                            value: roleDetail.role_key,

                                                        }}
                                                    />
                                                    <CustomInput
                                                        labelText="Name"
                                                        id="name"
                                                        success={this.state.nameState === "success"}
                                                        error={this.state.nameState === "error"}
                                                        formControlProps={{
                                                            fullWidth: true,
                                                            required: true
                                                        }}
                                                        inputProps={{
                                                            onChange: event =>
                                                                this.change(event, "name", "name", "required"),
                                                            value: roleDetail.role_name,
                                                        }}
                                                    />
                                                    <CustomInput
                                                        labelText="Description"
                                                        id="description"
                                                        success={this.state.descriptionState === "success"}
                                                        error={this.state.descriptionState === "error"}
                                                        formControlProps={{
                                                            fullWidth: true,
                                                            required: true
                                                        }}
                                                        inputProps={{
                                                            onChange: event =>
                                                                this.change(event, "description", "name", "required"),
                                                            value: roleDetail.role_description
                                                        }}
                                                    />
                                                    <FormControl
                                                        fullWidth>
                                                        <InputLabel
                                                            htmlFor="clinicmaster_id">
                                                            Clinic Master
                                                        </InputLabel>
                                                        <Select
                                                            value={this.state.clinicmaster_id}
                                                            onChange={this.onChangeSelect}
                                                            inputProps={{
                                                                name: "clinicmaster_id",
                                                                id: "clinicmaster_id"
                                                            }}
                                                        >
                                                            <MenuItem
                                                                disabled
                                                            >
                                                                Select Clinic
                                                            </MenuItem>
                                                            {data.map((x) => {
                                                                return <MenuItem key={Math.random()}
                                                                                 style={{height: "1.8em"}}
                                                                                 value={x.clinicmaster_id}>{x.clinicmaster_name ? x.clinicmaster_name : "No Name"}</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>
                                                    <InputLabel>
                                                        Choose Clinic Master
                                                    </InputLabel>&nbsp;&nbsp;
                                                    <br/>
                                                    <br/>
                                                    <InputLabel>
                                                        Active
                                                    </InputLabel>&nbsp;&nbsp;
                                                    <input type={"checkbox"} name={"is_active"}
                                                           checked={this.state.is_active}
                                                           onChange={this.onCheckActive} value={this.state.is_active}/>
                                                </GridItem>
                                                <GridItem xs={12} sm={7} md={5}>
                                                    <InputLabel>
                                                        Permissions
                                                    </InputLabel>&nbsp;&nbsp;
                                                    <br/>
                                                    <br/>
                                                    <b>Clinic Master {this.GroupCheckbox("1")}</b><br/><br/>
                                                    {
                                                        array1.map(item => (
                                                            <label key={item._id}>
                                                                {this.Checkbox(item.permission_key, this.state[`${item.permission_key}`] ? this.state[`${item.permission_key}`] : false)}
                                                                {item.permission_label}
                                                                <br/>
                                                            </label>
                                                        ))
                                                    }<br/><br/>
                                                    <b>Clinic {this.GroupCheckbox("2")}</b><br/><br/>
                                                    {
                                                        array2.map(item => (
                                                            <label key={item._id}>
                                                                {this.Checkbox(item.permission_key, this.state[`${item.permission_key}`] ? this.state[`${item.permission_key}`] : false)}
                                                                {item.permission_label}
                                                                <br/>
                                                            </label>
                                                        ))
                                                    }<br/><br/>
                                                    <b>Doctor {this.GroupCheckbox("3")}</b><br/><br/>
                                                    {
                                                        array3.map(item => (
                                                            <label key={item._id}>
                                                                {this.Checkbox(item.permission_key, this.state[`${item.permission_key}`] ? this.state[`${item.permission_key}`] : false)}
                                                                {item.permission_label}
                                                                <br/>
                                                            </label>
                                                        ))
                                                    }<br/><br/>
                                                    <b>Chat {this.GroupCheckbox("4")}</b><br/><br/>
                                                    {
                                                        array4.map(item => (
                                                            <label key={item._id}>
                                                                {this.Checkbox(item.permission_key, this.state[`${item.permission_key}`] ? this.state[`${item.permission_key}`] : false)}
                                                                {item.permission_label}
                                                                <br/>
                                                            </label>
                                                        ))
                                                    }<br/><br/>
                                                    <b>Users {this.GroupCheckbox("5")}</b><br/><br/>
                                                    {
                                                        array5.map(item => (
                                                            <label key={item._id}>
                                                                {this.Checkbox(item.permission_key, this.state[`${item.permission_key}`] ? this.state[`${item.permission_key}`] : false)}
                                                                {item.permission_label}
                                                                <br/>
                                                            </label>
                                                        ))
                                                    }<br/><br/>
                                                    <b>Patient {this.GroupCheckbox("6")}</b><br/><br/>
                                                    {
                                                        array6.map(item => (
                                                            <label key={item._id}>
                                                                {this.Checkbox(item.permission_key, this.state[`${item.permission_key}`] ? this.state[`${item.permission_key}`] : false)}
                                                                {item.permission_label}
                                                                <br/>
                                                            </label>
                                                        ))
                                                    }<br/><br/>
                                                    <b>Reports {this.GroupCheckbox("7")}</b><br/><br/>
                                                    {
                                                        array7.map(item => (
                                                            <label key={item._id}>
                                                                {this.Checkbox(item.permission_key, this.state[`${item.permission_key}`] ? this.state[`${item.permission_key}`] : false)}
                                                                {item.permission_label}
                                                                <br/>
                                                            </label>
                                                        ))
                                                    }<br/><br/>
                                                    <b>Reminders {this.GroupCheckbox("8")}</b><br/><br/>
                                                    {
                                                        array8.map(item => (
                                                            <label key={item._id}>
                                                                {this.Checkbox(item.permission_key, this.state[`${item.permission_key}`] ? this.state[`${item.permission_key}`] : false)}
                                                                {item.permission_label}
                                                                <br/>
                                                            </label>
                                                        ))
                                                    }<br/><br/>
                                                    <b>Marketing {this.GroupCheckbox("9")}</b><br/><br/>
                                                    {
                                                        array9.map(item => (
                                                            <label key={item._id}>
                                                                {this.Checkbox(item.permission_key, this.state[`${item.permission_key}`] ? this.state[`${item.permission_key}`] : false)}
                                                                {item.permission_label}
                                                                <br/>
                                                            </label>
                                                        ))
                                                    }<br/><br/>

                                                    <b>Admin {this.GroupCheckbox("10")}</b><br/><br/>
                                                    {
                                                        array10.map(item => (
                                                            <label key={item._id}>
                                                                {this.Checkbox(item.permission_key, this.state[`${item.permission_key}`] ? this.state[`${item.permission_key}`] : false)}
                                                                {item.permission_label}
                                                                <br/>
                                                            </label>
                                                        ))
                                                    }<br/><br/>
                                                    <b>Appointments {this.GroupCheckbox("11")}</b><br/><br/>
                                                    {
                                                        array11.map(item => (
                                                            <label key={item._id}>
                                                                {this.Checkbox(item.permission_key, this.state[`${item.permission_key}`] ? this.state[`${item.permission_key}`] : false)}
                                                                {item.permission_label}
                                                                <br/>
                                                            </label>
                                                        ))
                                                    }<br/><br/>


                                                </GridItem>
                                            </GridContainer>
                                        </form>
                                        <CardFooter>
                                            <Button type={"submit"} color="warning" onClick={this.onSubmit}>
                                                Update
                                            </Button>
                                            <NavLink to={dashboardRouter(`/roles/clinic`)}>
                                                <Button color="grey">
                                                    Cancel
                                                </Button></NavLink>
                                        </CardFooter>
                                    </GridItem>
                                </GridContainer></CardBody></Card></GridItem>
                </GridContainer>
            )
        else
            return (
                <div>
                    <Loader/>
                </div>
            )
    }

    CallReadApi = (clinicid, id) => {
        api.listClinicMaster().then(json => {
            this.setState({data: json.data.data})
        });
        api.getPermissionForClinic(clinicid).then(json => {
            this.setState({
                roleDetail: json.data.filter(x => x._id === id)[0]
            }, () => (
                this.checkAcesss(), this.setState({is_active: this.state.roleDetail.active})
            ))
        });
        api.getAllPermissionList().then(json => {
            this.splittingArrayByRole(json.data)
            this.setState({permissions: json.data})
        });
    }

    onSubmit() {
        const postBody = {
            updated_object: {
                // "role_key": this.state.roleDetail.role_key,
                // "role_name": this.state.roleDetail.name,
                // "role_description": this.state.roleDetail.description,
                role_access: this.state.role_access,
                // "clinic_master_id": this.state.clinicmaster_id,
                active: this.state.is_active ? this.state.is_active : this.state.roleDetail.active
            },
            _id: this.state.roleDetail._id
        };
        api.editClinicRoles(postBody)
            .then(json => {
                if (json.data.data._id) {
                    var msgcolor = {message: "Role updated Successfully!", color: "success"};
                    this.props.generateNotification(msgcolor);
                    this.props.history.push(dashboardRouter('/clinic/role/view/' + this.state.clinicmaster_id))
                }
                else {
                    var msgcolor = {message: "Error in adding!", color: "danger"};
                    this.props.generateNotification(msgcolor);
                }
            }).catch(err => {
            var msgcolor = {message: "Error in adding!", color: "danger"};
            this.props.generateNotification(msgcolor);
        })
    }


    change(event, stateName, type, inputType, maxValue) {
        this.setState({[stateName]: event.target.value});
        switch (type) {
            case "email":
                if (this.verifyEmail(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                }
                else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "name":
                if (this.verifyName(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                }
                else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "number":
                if (this.verifyNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                }
                else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "phonenumber":
                if (this.verifyPhoneNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                }
                else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "alphanum":
                if (this.verifyAlphaNum(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                }
                else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "novalidation":
                if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                }
                else if (event.target.value === "" && inputType === "required") {
                    this.setState({[stateName + "State"]: "error"});
                }
                else {
                    this.setState({[stateName + "State"]: "success"});
                }
                break;
            default:
                break;
        }
    }

    verifyEmail(value) {
        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRex.test(value)) {
            return true;
        }
        return false;
    }

    verifyName(value) {
        var nameRex = /^(?![ .]+$)[a-zA-Z .]+$/;
        if (nameRex.test(value)) {
            return true;
        }
        return false;
    }

    verifyAlphaNum(value) {
        var alphanumRex = new RegExp("^[0-9a-zA-Z]+$");
        if (alphanumRex.test(value)) {
            return true;
        }
        return false;
    }

    verifyPhoneNumber(value) {
        var numberRex = new RegExp("^[0-9]+$");
        if (numberRex.test(value) && value.length === 10) {
            return true;
        }
        return false;
    }


    Checkbox = (name, value) => (
        <input type={'checkbox'} name={name} checked={this.state[`${name}`] ? this.state[`${name}`] : false}
               onChange={e => this.onCheck(e.target.name, e.target.checked)}/>
    );

    GroupCheckbox(name) {
        return <input type={'checkbox'} name={name}
                      onChange={this.onGroupCheck}/>
    }

    splittingArrayByRole(array) {
        array.forEach(obj => {
            // if statements or switch statement depending on how you want to split
            switch (obj.permission_category) {
                case 'Clinic Master':
                    array1.push(obj);
                    break;
                case 'Clinic':
                    array2.push(obj);
                    break;
                case 'Doctor':
                    array3.push(obj);
                    break;
                case 'Chat':
                    array4.push(obj);
                    break;
                case 'Users':
                    array5.push(obj);
                    break;
                case 'Patient':
                    array6.push(obj);
                    break;
                case 'Reports':
                    array7.push(obj);
                    break;
                case 'Reminders':
                    array8.push(obj);
                    break;
                case 'Marketing':
                    array9.push(obj);
                    break;
                case 'Admin':
                    array10.push(obj);
                    break;
                case 'Appointments':
                default:
                    array11.push(obj);
                    break;
            }
        })
    }
}

export default ClinicRoleUpdate


// WEBPACK FOOTER //
// ./src/views/Roles/Clinic/ClinicRoleUpdate.jsx